module.exports = __webpack_public_path__ + "img/1sshopping-drawer.ccda2dd1.png";